import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/http';

export type TimelineEventType =
  | 'CaseOpened'
  | 'DemandApproved'
  | 'AllocationStarted'
  | 'BookingConfirmed'
  | 'BookingFailed'
  | 'ReservationCancelled'
  | 'CompensationStarted'
  | 'CompensationCompleted'
  | 'NotificationDispatched'
  | 'CaseResolved';

export interface TimelineEntry {
  entryUrn: string;
  ts: string;
  type: TimelineEventType;
  /** Saga-compensation entries render with a distinguishing icon. */
  isCompensation: boolean;
  correlationUrn: string;
  summary: string;
  details?: string | null;
}

export function useTimeline(caseUrn: string) {
  return useQuery<TimelineEntry[]>({
    queryKey: ['cases', caseUrn, 'timeline'],
    queryFn: () =>
      http.get(`v1/cases/${encodeURIComponent(caseUrn)}/timeline`).json<TimelineEntry[]>(),
    staleTime: 60_000,
    enabled: !!caseUrn,
  });
}
